import dateFormat from 'node-datetime'

const dateFormatDirective = {

  convertDateAsc(date) {
    return dateFormat.create(date).format('Y-m-dTH:M:S');
  },

  convertDateDesc(date) {
    return dateFormat.create(date).format('m/d/Y H:M:S');
  },

  convertDateAscWithoutT(date) {
    return dateFormat.create(date).format('Y-m-d H:M:S');
  }
};

export default dateFormatDirective;
